export default "__VITE_ASSET__QZxwBQp1__"